import { SxProps } from '@mui/material/styles'

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}

/**
 * Merges multiple sx props, including null and undefined values.
 */
function mergeSx<TTheme extends object>(...sx: (SxProps<TTheme> | undefined | null)[]) {
  if (sx.every(sx => !sx)) return undefined
  return sx.filter(notEmpty) as SxProps<TTheme> // SxProps can also be an array of other SxProps (see MUI docs)
}

export default mergeSx
